/**
 * DAT-561 · Which notifications a viewport is allowed to show.
 *
 * The Employee Status Review digest is the first "desktop-only" notification: its only action is the
 * Team page's pending-decision filter, which — like the "!" banner that launches it — is web-only, so
 * on mobile the Team page renders the plain staff list and the notification would be a dead end.
 * Product decision (DAT-561): hide it on mobile rather than link nowhere.
 */

import { type NotificationResponse, NotificationType } from "./models";

const DESKTOP_ONLY_NOTIFICATION_TYPES: ReadonlySet<string> = new Set<string>([NotificationType.EmployeeStatusDecision]);

/** Drops desktop-only notifications when the viewport is mobile; the desktop list passes through. */
export function visibleNotificationsForViewport(notifications: NotificationResponse[], isMobile: boolean): NotificationResponse[] {
	if (!isMobile) return notifications;
	return notifications.filter((notification) => !DESKTOP_ONLY_NOTIFICATION_TYPES.has(notification.notification_type));
}
